import Vue from "vue";
import Router from "vue-router";
import Dashboard from "@/components/Dashboard.vue";
import Project from "@/components/Project.vue";
import Infrahub from "@/components/Infrahub.vue";

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  mode: "history",
  routes: [
    {
    path: "/",
    name: "Home",
    component: Project,
    },
    {
    path: "/project",
    name: "Project",
    component: Project,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
    },
    {
      path: "/infrahub",
      name: "Infrahub",
      component: Infrahub,
    },
  ],
});
